module.exports = __webpack_public_path__ + "media/images/member@2x-deec5b436e968d6808fb9e7734914529.gif";